/**
 * demoDetection.ts — Wrapper around demoState.ts
 *
 * All existing imports continue to work unchanged.
 * Logic has moved to demoState.ts — do not add detection logic here.
 *
 * Place at: src/demo/demoDetection.ts
 */

import { anchorDemoClock } from './demoClock';
import { captureDemoSource } from './demoAnalytics';
import {
  initDemoState,
  isDemoMode as _isDemoMode,
  exitDemoState,
  resetDemoState,
  demoOr as _demoOr,
} from './demoState';

export function initDemoMode(): boolean {
  const state = initDemoState();
  if (state.isDemo) {
    anchorDemoClock();
    captureDemoSource();
  }
  return state.isDemo;
}

export function isDemoMode(): boolean {
  return _isDemoMode();
}

export function exitDemoMode(): void {
  exitDemoState();
}

export function resetDemoMode(): void {
  resetDemoState();
}

export function demoOr<T>(getDemo: () => T, getLive: () => T): T {
  return _demoOr(getDemo, getLive);
}
